import supportsWebp from './supportsWebp';

export const createWebpSupportClassHandler = (detectionFn = supportsWebp) => async element => {
  const isWebpSupported = await detectionFn();

  if (!isWebpSupported) {
    element.classList.add('no-webp');
  }
};

export default createWebpSupportClassHandler();
